<form class="page-fix-form-new-window-options" #form="ngForm">
    <div class="px-4 py-6">
        <h2 class="mt-0" translate>Repair options</h2>
        <strong translate class="mb-1 inline-block">Default fix</strong>
        <div class="setting-container">
            <div class="form-group row mb-0">
                <label class="col-48" for="new_window_text">
                    <span translate>Choose your own text for the warning pop-up</span><span class="fas fa-question-circle"
                          ngbTooltip="{{ 'Write a warning to your outbound link' | translate }}"
                          aria-hidden="true">
                    </span>
                </label>
                <div class="col pr-0">
                    <input type="text"
                           class="form-control"
                           name="text"
                           [(ngModel)]="newWindowText"
                           required
                           id="new_window_text"
                           #textInput="ngModel"/>
                    <div class="row">
                        <form-field-errors [input]="textInput" offset="0">
                        </form-field-errors>
                    </div>
                </div>
                <div class="col-auto pl-2">
                    <button class="btn btn-border-radius btn-link btn-reset-text"
                            (click)="resetText()"
                            ngbTooltip="{{ 'Reset' | translate }}"
                            type="button">
                        <span class="sr-only" translate>
                            Reset Input
                        </span>
                        <span class="fas fa-redo-alt fa-lg" aria-hidden="true"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>
